import Utils from "../../../../Utils.js";
class Index {
    rc;
    _parent;
    constructor(_parent) {
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/files`;
    }
    /**
     * Posts a file or multiple files.
     * HTTP Method: post
     * Endpoint: /team-messaging/v1/files
     * Rate Limit Group: Heavy
     * App Permission: TeamMessaging
     */
    async post(createGlipFileNewRequest, queryParams, restRequestConfig) {
        const formData = await Utils.getFormData(createGlipFileNewRequest);
        const r = await this.rc.post(this.path(), formData, queryParams, restRequestConfig);
        return r.data;
    }
}
export default Index;
